import { CHOIR_VOICES, TChoirVoice } from "../../../../../../common/types/choir/meta/general";

export const translateVoices = (voices: TChoirVoice[]) => {
    return CHOIR_VOICES.filter(cv => voices.includes(cv)).map(voice => {
        const base = voice.slice(0, 1);
        const number = voice.slice(1, 2) || '';
        const numberText = number && ` ${number}`;
        switch (base) {
            case 'S':
                return 'Szoprán' + numberText;
            case 'A':
                return 'Alt' + numberText;
            case 'M':
                return 'Mezzo';
            case 'T':
                return 'Tenor' + numberText;
            case 'B':
                return 'Basszus' + numberText;
        }
    })
}
